/**
 * Inject HTML into a container element and execute any script tags.
 * React's dangerouslySetInnerHTML doesn't execute scripts — this does.
 */
export function injectHTML(container: HTMLElement, html: string): void {
    container.innerHTML = html;

    const scripts = container.querySelectorAll("script");
    scripts.forEach((oldScript) => {
        const newScript = document.createElement("script");
        oldScript.getAttributeNames().forEach((name) => {
            newScript.setAttribute(name, oldScript.getAttribute(name)!);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode?.replaceChild(newScript, oldScript);
    });
}
